/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The CreateGroupRequest model module.
* @module model/CreateGroupRequest
* @version 2020-12-7
*/
export default class CreateGroupRequest {
    /**
    * Constructs a new <code>CreateGroupRequest</code>.
    * グループ登録リクエスト
    * @alias module:model/CreateGroupRequest
    * @class
    * @param groupName {String} グループ名
    * @param groupType {String} グループタイプ
    * @param parentGroupId {Number} 親グループID
    */

    constructor(groupName, groupType, parentGroupId) {
        
        
        this['groupName'] = groupName;
        this['groupType'] = groupType;
        this['parentGroupId'] = parentGroupId;
        
    }

    /**
    * Constructs a <code>CreateGroupRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateGroupRequest} obj Optional instance to populate.
    * @return {module:model/CreateGroupRequest} The populated <code>CreateGroupRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateGroupRequest();
                        
            
            if (data.hasOwnProperty('groupName')) {
                obj['groupName'] = ApiClient.convertToType(data['groupName'], 'String');
            }
            if (data.hasOwnProperty('groupType')) {
                obj['groupType'] = ApiClient.convertToType(data['groupType'], 'String');
            }
            if (data.hasOwnProperty('parentGroupId')) {
                obj['parentGroupId'] = ApiClient.convertToType(data['parentGroupId'], 'Number');
            }
            if (data.hasOwnProperty('remarks')) {
                obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String');
            }
        }
        return obj;
    }

    /**
    * グループ名
    * @member {String} groupName
    */
    'groupName' = undefined;
    /**
    * グループタイプ
    * @member {String} groupType
    */
    'groupType' = undefined;
    /**
    * 親グループID
    * @member {Number} parentGroupId
    */
    'parentGroupId' = undefined;
    /**
    * 備考
    * @member {String} remarks
    */
    'remarks' = undefined;




}
